import EventTreeVertex from '../EventTreeVertex';
import EndStateVertexValue from './EndStateVertexValue';
import Outcome, {OutcomeJSON} from "../../HCLTreeVertexValue/Outcome";
import ReferenceTypes from "../../HCLTreeVertexValue/ReferenceTypes";
import ProxyTypes from "../../HCLTreeVertexValue/ProxyTypes";
import {mxConstants, mxCylinder, mxGeometry, mxUtils} from "mxgraph-js";

class EndStateVertex extends EventTreeVertex {
  static SHAPE_KEY = 'esd-endstate';

  /**
   * Basic shape parameters, used and optionally overridden by child classes
   * @type {{RADIUS: number, WIDTH: number, HEIGHT: number, GATE: number}}
   */
  static SHAPE = {
    HEIGHT: 70,
    WIDTH: 100,
    RADIUS: 10,
    GATE: 20,
  };

  /**
   * @return {() => void}
   */
  static getShape(): () => void {
    function EndStateVertexShape() { mxCylinder.call(this); }
    mxUtils.extend(EndStateVertexShape, mxCylinder);
    EndStateVertexShape.prototype.redrawPath = (c: any, x: any, y: any, w: any, h: any) => {
      const gateSize = EndStateVertex.SHAPE.GATE;
      const halfSize = gateSize / 2;
      const theta = 60.0;
      const adjacent = Math.tan(theta * Math.PI / 180.0) * halfSize;
      const midX = w * 0.5;
      c.moveTo(midX, h - gateSize); // TOP
      c.lineTo(midX - adjacent, h - halfSize);
      c.lineTo(midX, h);
      c.lineTo(midX + adjacent, h - halfSize);
      c.close();
      c.fillAndStroke();
      const radius = EndStateVertex.SHAPE.RADIUS;
      c.roundrect(0, 0, w, h - gateSize - 2, radius, radius);
    };
    return EndStateVertexShape;
  }

  /**
   * @param {string} key
   * @param {EndStateVertexValue} value
   */
  constructor(key: string, value: EndStateVertexValue) {
    super(key, value);
  }

  /**
   * @override
   * @return {MxGraphType.mxGeometry}
   */
  getMyGeometry(): mxGeometry {
    return new mxGeometry(0, 0, EndStateVertex.SHAPE.WIDTH, EndStateVertex.SHAPE.HEIGHT);
  }

  /**
   * @override
   * @return {[index: string]: any}
   */
  getMyStyle(): {[index: string]: any} {
    const style: {[index: string]: any} = {};
    style[mxConstants.STYLE_ROUNDED] = 0;
    style[mxConstants.STYLE_SPACING] = 6;
    style[mxConstants.STYLE_FONTSIZE] = '12';
    style[mxConstants.STYLE_FONTFAMILY] = 'Roboto Condensed';
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    style[mxConstants.STYLE_OVERFLOW] = 'hidden';
    style[mxConstants.STYLE_SHAPE] = EndStateVertex.SHAPE_KEY;
    style[mxConstants.STYLE_SPACING_BOTTOM] = EndStateVertex.SHAPE.GATE;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(238,152,56,0.20)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(238,152,56,0.75)';
    style[mxConstants.STYLE_FILL_OPACITY] = '60';
    style[mxConstants.STYLE_STROKE_OPACITY] = '60';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    return style;
  }

  getType(): string {
    return "End State";
  }

  // inactiveStyle() {
  //   const { style } = this.getMyStyle();
  //   style[MxGraph.mxConstants.STYLE_FILLCOLOR] = '#433d3a';
  //   style[MxGraph.mxConstants.STYLE_STROKECOLOR] = '#5f5858';
  //   style[MxGraph.mxConstants.STYLE_STROKE_OPACITY] = '60';
  //   style[MxGraph.mxConstants.STYLE_FILL_OPACITY] = '0';
  //   style[MxGraph.mxConstants.STYLE_STROKEWIDTH] = '1';
  //   return style;
  // }
  //
  // activeStyle() {
  //   const { style } = EndStateVertex;
  //   return style;
  // }

  toReferenceJSON(): OutcomeJSON {
    return new Outcome(this.getKey(), ReferenceTypes.SEQUENCES, this.getGraph().getModelTreeId(), "", ProxyTypes.END_STATE).toJSON();
  }

  clone(): EndStateVertex {
    return new EndStateVertex(null, this.value.clone());
  }
}

export default EndStateVertex;
